import request from "@/utils/request";

export async function upload3(data) {
  return request({
    url: "/FileUpload/FileUpload",
    method: "post",
    data: data,
  });
}
